<template>
  <div>
    <b-row class="form-group">
      <b-col cols="12" class="">
        <v-select
          v-model="value"
          @search="searchBIller"
          style="w-100"
          :getOptionLabel="(option) => option.name"
          :options="biller"
          placeholder="Select Biller"
          @input="Input"
        ></v-select>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "Pick Biller",
  value: {
    value: {
      type: String,
      default: "",
    },
  },
  mounted: function() {
    this.value = { id: 1, name: "Test Biller" };
  },
  data: () => ({
    biller: [{ id: 1, name: "Test Biller" }],
  }),
  methods: {
    searchBIller() {},
    Input(val) {
      this.$emit("input", val);
    },
  },
};
</script>
